import { useCallback, useMemo } from 'react'
import { Bug } from 'lucide-react'
import { PageHeader } from '@/shell/AppShell'
import { DataTable } from '@/components/DataTable'
import type { AdminColumn } from '@/components/DataTable/types'
import { PERMISSIONS } from '@/lib/permissions'
import { fetchErrorTraces, DT_STR as S, type ErrorTraceRow } from './devtoolsApi'

/**
 * A27.06 — Трассировка ошибок. Error traces / failed job runs, read-only.
 * Wired to the real `/admin/job-runs?status=error` (fail-soft to empty until
 * it ships). Placeholder permission USERS_VIEW.
 */
export function ErrorTraceScreen() {
  const columns = useMemo<AdminColumn<ErrorTraceRow>[]>(
    () => [
      { key: 'at', header: S.at, type: 'text' },
      { key: 'level', header: S.level, type: 'text' },
      { key: 'service', header: S.service, type: 'text' },
      { key: 'message', header: S.message, type: 'longtext' },
      { key: 'trace_id', header: S.traceId, type: 'text' },
    ],
    [],
  )
  const fetcher = useCallback(fetchErrorTraces, [])
  return (
    <>
      <PageHeader title={S.errorTrace} screenId="A27.06" />
      <DataTable<ErrorTraceRow>
        screenId="A27.06"
        permission={PERMISSIONS.USERS_VIEW}
        columns={columns}
        fetcher={fetcher}
        rowId={(r) => String(r.id)}
        exportable
        emptyState={{ icon: <Bug size={28} strokeWidth={1.5} /> }}
      />
    </>
  )
}
